module.exports = __webpack_public_path__ + "img/IMG_9543_L_Wood_MockedUp.fa9765ca.jpg";